import React from 'react'
import { Modal, ModalHeader, Button } from 'reactstrap';
import { FormCard } from './FormCard';
import { Dialog } from 'primereact/dialog';



export const ModalCard = (props) => {
    const {
        modalCard, toggleCard, modalTitleCard, loading, method, typeCard = "typeCard", checkbox, check,
        handleCheckboxChange, handleInputChangeT, id_departament, departament, handleSectionUser,
        section, changeTree, treeviewRef, tree, onRenderItem, flag, processes, saveCardCode,
        handleListSectionsCard, card_code, handleInputChange, checkSection, handleCheckChange,
        listDepartament, handleSelectValues, formUser, id_departaments, listDepa, handleListCedula, url_helen,
        name_user

    } = props;
    console.log("🚀 ~ ModalCard ~ name_user:", name_user)

    return (
        <Dialog
            header={"Accesos del usuario"}
            visible={modalCard}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            onHide={toggleCard}
            // className="pt-0 custom-dialog-img"
            footer={
                <>
                    <Button

                        size="sm"
                        color="danger"
                        onClick={toggleCard}
                    >
                        {"Cancelar"}
                    </Button>
                    <Button

                        size="sm"
                        color="primary"
                        onClick={() => saveCardCode()}
                        className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""} disabled={loading}>
                        {"Guardar"}
                    </Button>
                </>

            }
        >
            {
                typeCard === "typeCard"
                    ?
                    <FormCard button='Guardar' {...{
                        toggleCard, loading, modalCard, modalTitleCard,
                        handleCheckboxChange, method, typeCard, checkbox, check, handleInputChangeT,
                        id_departament, departament, handleSectionUser, section, changeTree, treeviewRef, tree,
                        onRenderItem, processes, methodAction: saveCardCode, handleListSectionsCard,
                        card_code, handleInputChange, checkSection, handleCheckChange, listDepartament,
                        handleSelectValues, formUser, id_departaments, listDepa, url_helen, name_user
                    }} />
                    : " "
            }

        </Dialog>



    )
}
